/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Density_AutoInputs */

const en_disp_density_auto = /** @type {(inputs: Disp_Density_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const de_disp_density_auto = /** @type {(inputs: Disp_Density_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Disp_Density_AutoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_density_auto = /** @type {((inputs?: Disp_Density_AutoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Density_AutoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_density_auto(inputs)
	return en_disp_density_auto(inputs)
});